import BaseSystemApi from 'api/BaseSystemApi';

export default class WebhooksSystemApi<Resource = unknown> extends BaseSystemApi<Resource> {
  protected origin = process.env.REACT_APP_WEBHOOKS_API_URL;
}
